/*
 * Good Chef Bad Chef video mapping helper.
 *
 * Shared logic lives in /js/pixmoto_video_mapping_common.js.
 */
(() => {
  const mappingScriptEl = document.currentScript || null;
  function run() {
    if (!window.PixmotoVideoMapping) {
      return;
    }
    const runner = window.PixmotoVideoMapping.createRunner({
      runtimePrefix: "GS_BF",
      // Single selector covers both cases on a Squarespace recipe page:
      // `.intrinsic` is the outer aspect-ratio wrapper that holds either
      // an `.embed-block-wrapper` (YouTube embed) or an `.image-inset`
      // (classic image block). Substituting at this level means the
      // runner doesn't have to know which media type the publisher used.
      targetSelector: ".intrinsic",
      scriptElement: mappingScriptEl,
    });
    runner();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
